import { notification } from 'antd';

export const notify = {
  error: (message: string, className?: string) =>
    notification.error({ message, className }),

  success: (message: string, className?: string) =>
    notification.success({ message, className }),
};
